import { Controller } from "@hotwired/stimulus";

class DisableOnClick {
  private element: HTMLButtonElement;

  constructor(element: HTMLButtonElement) {
    this.element = element;
  }

  connect(): void {
    this.element.addEventListener("click", this.disableOnClick.bind(this));
  }

  disconnect(): void {
    this.element.removeEventListener("click", this.disableOnClick.bind(this));
  }

  private disableOnClick(_event: Event): void {
    setTimeout(() => {
      (this.element as HTMLButtonElement).disabled = true;
    }, 10);
  }
}

class EnableOnFormChange {
  private element: HTMLButtonElement;

  constructor(element: HTMLButtonElement) {
    this.element = element;
  }

  connect(): void {
    const form = (this.element as HTMLButtonElement).form;
    if (form) {
      form.addEventListener("input", this.enableOnFormChange.bind(this));
      form.addEventListener("change", this.enableOnFormChange.bind(this));
    }
  }

  disconnect(): void {
    const form = (this.element as HTMLButtonElement).form;
    if (form) {
      form.removeEventListener("input", this.enableOnFormChange.bind(this));
      form.removeEventListener("change", this.enableOnFormChange.bind(this));
    }
  }

  private enableOnFormChange(_event: Event) {
    this.element.disabled = false;
  }
}

export default class extends Controller {
  static values = {
    disableOnClick: Boolean,
    enableOnFormChange: Boolean,
  };

  declare disableOnClickManager?: DisableOnClick;
  declare enableOnFormChangeManager?: EnableOnFormChange;
  declare readonly disableOnClickValue: boolean;
  declare readonly enableOnFormChangeValue: boolean;

  override connect(): void {
    if (this.disableOnClickValue) {
      this.disableOnClickManager = new DisableOnClick(this.element as HTMLButtonElement);
      this.disableOnClickManager.connect();
    }
    if (this.enableOnFormChangeValue) {
      this.enableOnFormChangeManager = new EnableOnFormChange(this.element as HTMLButtonElement);
      this.enableOnFormChangeManager.connect();
    }
  }

  override disconnect(): void {
    this.disableOnClickManager?.disconnect();
    this.enableOnFormChangeManager?.disconnect();
  }
}
